// Genel amaçlı onay modal'ı
import React from 'react';
import { FiX } from 'react-icons/fi';

const ConfirmModal = ({ 
  title, 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = 'Onayla',
  cancelText = 'İptal',
  isLoading = false,
  IconComponent
}) => {
  // Overlay'e tıklayınca modal'ı kapat
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !isLoading) {
      onCancel();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content max-w-md">
        {/* Modal header */}
        <div className="modal-header">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              {IconComponent ? <IconComponent className="mr-2 text-white" size={20} /> : null}
              <h3 className="text-lg font-medium text-white">{title}</h3>
            </div>
            <button
              onClick={onCancel}
              className="text-white hover:text-gray-300"
              disabled={isLoading}
            >
              <FiX size={20} />
            </button>
          </div>
        </div>

        {/* Modal body */}
        <div className="p-6">
          <p className="text-gray-700 dark:text-gray-300">{message}</p>
        </div>

        {/* Modal footer */}
        <div className="flex items-center justify-end space-x-3 px-6 py-4">
          <button
            onClick={onCancel}
            className="btn-secondary"
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="btn-danger"
            disabled={isLoading}
          >
            {isLoading ? 'İşlem yapılıyor...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;


